/**
 * Formats a numeric amount in cents to a EUR price string with proper locale formatting.
 * @param amount - The price amount in cents (e.g., 1000 = €10.00)
 * @returns A formatted EUR price string with € symbol, thousands separators, and two decimal places
 * @example
 * formatEuroPrice(1000) // "€10.00"
 * formatEuroPrice(1234567) // "€12,345.67"
 */
export function formatEuroPrice(amount: number) {
  return `€${(amount / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  })}`;
}
